import { getCSRFToken } from "../shared/htmx-helpers.js";

const PENDING_KEY = "editor_pending_save";

export function queueSave(url, content) {
  const pending = JSON.parse(localStorage.getItem(PENDING_KEY) || "[]");
  // Only keep the latest save for a given URL to avoid redundant requests
  const others = pending.filter((p) => p.url !== url);
  others.push({ url, content, timestamp: Date.now() });
  localStorage.setItem(PENDING_KEY, JSON.stringify(others));
}

export function getPendingSaves() {
  return JSON.parse(localStorage.getItem(PENDING_KEY) || "[]");
}

export function clearPendingSaves() {
  localStorage.removeItem(PENDING_KEY);
}

export async function flushPendingSaves() {
  const pending = getPendingSaves();
  if (!pending.length) return;

  console.log("Flushing pending saves...", pending.length);

  // Process sequentially
  for (const item of pending) {
    try {
      const response = await fetch(item.url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          // Without the CSRF token the PUT 403s on reconnect and the queued
          // save is dropped — the token lives in <meta name="csrf-token">.
          "X-CSRF-Token": getCSRFToken(),
        },
        body: JSON.stringify({ content: item.content }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
    } catch (e) {
      console.error("Failed to flush save for", item.url, e);
      // If one fails, stop processing to preserve order/integrity?
      // Or maybe keep trying others? For now, we stop to be safe.
      return;
    }
  }
  clearPendingSaves();
  // Dispatch event so store can update status if needed
  window.dispatchEvent(new CustomEvent("editor:flushed"));
}

// Auto-flush when coming back online
if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    console.log("Network restored, flushing saves...");
    flushPendingSaves();
  });
}
